import React, { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const VARIANTS = ['sm']

function ConceptButton({ animation, handleOnSelect, selected, title, variant }) {
  const { t } = useTranslation()

  const selectConcept = useCallback(() => {
    handleOnSelect(animation)
  }, [animation])

  const variantClass = variant ? `concept-button--${variant}` : ''

  return (
    <button
      className={`concept-button ${selected ? 'concept-button--selected' : ''} ${variantClass}`}
      type="button"
      onClick={selectConcept}
      onMouseEnter={selectConcept}
    >
      <div>{t(title)}</div>
      <div className="concept-button__arrow" />
    </button>
  )
}

ConceptButton.propTypes = {
  animation: PropTypes.string,
  handleOnSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(VARIANTS)
}

ConceptButton.defaultProps = {
  animation: '',
  variant: ''
}

export default memo(ConceptButton)
